<ng-container *ngIf="data$ | async as data">
    <h3>{{ data.title }}</h3>
</ng-container>
